import React, { useState, useEffect, useCallback } from 'react';

export default function Sidebar({ collapsed, onToggle, activeView, onNavigate }) {
  const [sidebarWidth, setSidebarWidth] = useState(240);
  const [isResizing, setIsResizing] = useState(false);
  
  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const menuGroups = [
    {
      type: 'item',
      id: 'dashboard',
      label: 'Dashboard',
      icon: (
        <img src={process.env.PUBLIC_URL + '/dashboard-64.png'} alt="Dashboard" style={{ width: '25px', height: '25px' }} />
      ),
    },
    { 
      type: 'group',
      id: 'sales-list', 
      label: 'Sales', 
      icon: (
        <img src={process.env.PUBLIC_URL + '/icons8-sales-64.png'} alt="Sales" style={{ width: '25px', height: '25px' }} />
      ),
      children: [
        { 
          id: 'customers', 
          label: 'Customers', 
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          )
        },
        {
          id: 'invoices',
          label: 'Invoices',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          )
        },
        {
          id: 'quotes',
          label: 'Quotes',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          )
        }
      ]
    },
    { 
      type: 'group',
      id: 'purchases-list',
      label: 'Purchases', 
      icon: (
        <img src={process.env.PUBLIC_URL + '/icons8-bill-64.png'} alt="Purchases" style={{ width: '25px', height: '25px' }} />
      ),
      children: [
        {
          id: 'supplier',
          label: 'Suppliers',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          )
        },
        {
          id: 'bills',
          label: 'Bills',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          )
        },
        {
          id: 'purchases',
          label: 'Purchase Orders',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          )
        }
      ]
    },
    { 
      type: 'group',
      id: 'inventory',
      label: 'Inventory', 
      icon: (
        <img src={process.env.PUBLIC_URL + '/icons8-barcode-scanner-64.png'} alt="Inventory" style={{ width: '25px', height: '25px' }} />
      ),
      children: [
        {
          id: 'items',
          label: 'Items',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          )
        },
      ]
    },
    {
      type: 'group',
      label: 'List',
      id: 'group-list',
      icon: (
        <img src={process.env.PUBLIC_URL + '/icons8-transaction-list-64.png'} alt="List" style={{ width: '25px', height: '25px' }} />
      ),
      children: [
        {
          id: 'category',
          label: 'Categories',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="8" y1="6" x2="21" y2="6"></line>
              <line x1="8" y1="12" x2="21" y2="12"></line>
              <line x1="8" y1="18" x2="21" y2="18"></line>
              <line x1="3" y1="6" x2="3.01" y2="6"></line>
              <line x1="3" y1="12" x2="3.01" y2="12"></line>
              <line x1="3" y1="18" x2="3.01" y2="18"></line>
            </svg>
          )
        },
        {
          id: 'tax',
          label: 'Taxes',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
          )
        }
      ]
    },
    {
      type: 'group',
      id: 'reports',
      label: 'Reports',
      icon: (
        <img src={process.env.PUBLIC_URL + '/icons8-report-64.png'} alt="Reports" style={{ width: '25px', height: '25px' }} />
      ),
      children: [
        {
          type: 'group',
          id: 'reports-sales',
          label: 'Sales',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
            </svg>
          ),
          children: [
            {
              id: 'sales-by-customer',
              label: 'Sales by customer',
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                </svg>
              )
            },
            {
              id: 'sales-by-item',
              label: 'Sales by item',
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                </svg>
              )
            },
          ]
        },
        {
          type: 'group',
          id: 'reports-purchase',
          label: 'Purchase',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
          ),
          children: [
            {
              id: 'purchase-by-supplier',
              label: 'Purchase by supplier',
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              )
            },
          ]
        },
        {
          type: 'group',
          id: 'reports-inventory',
          label: 'Inventory',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="3" y1="9" x2="21" y2="9"></line>
              <line x1="9" y1="21" x2="9" y2="9"></line>
            </svg>
          ),
          children: [
            {
              id: 'valuation',
              label: 'Valuation',
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              )
            },
          ]
        },
      ]
    },
  ];

  // Move settings to the bottom of the sidebar.
  menuGroups.push({
    type: 'item',
    id: 'organisationSettings',
    label: 'Settings',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V22a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 20.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 3.6a1.65 1.65 0 0 0 1-1.51V2a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 20.4 9a1.65 1.65 0 0 0 1.51 1H22a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
      </svg>
    ),
  });

  // Resizing Logic
  const startResizing = useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
  }, []);

  const stopResizing = useCallback(() => {
    setIsResizing(false);
  }, []);

  const resize = useCallback((e) => {
    if (isResizing) {
      let newWidth = e.clientX;
      if (newWidth < 150) newWidth = 150;
      if (newWidth > 240) newWidth = 240;
      setSidebarWidth(newWidth);
    }
  }, [isResizing]);

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  const getLeafItems = (entry) => {
    if (!entry.children) return [entry];
    return entry.children.flatMap(child => getLeafItems(child));
  };

  const renderMenuEntry = (entry, depth = 0) => {
    if (!entry.children) {
      return (
        <div
          key={entry.id}
          onClick={() => onNavigate(entry.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 20px',
            paddingLeft: (!collapsed && depth > 0) ? `${20 + depth * 16}px` : '20px',
            cursor: 'pointer',
            backgroundColor: activeView === entry.id ? '#e7f5ff' : 'transparent',
            color: activeView === entry.id ? '#1971c2' : '#495057',
            borderRight: activeView === entry.id ? '3px solid #1971c2' : '3px solid transparent',
            justifyContent: collapsed ? 'center' : 'flex-start',
            transition: 'all 0.2s ease',
          }}
          title={collapsed ? entry.label : ''}
        >
          <div style={{ display: 'flex', alignItems: 'center', minWidth: '20px' }}>{entry.icon}</div>
          {!collapsed && (
            <span style={{ marginLeft: '12px', fontWeight: 500, fontSize: '0.95em' }}>
              {entry.label}
            </span>
          )}
        </div>
      );
    }

    if (collapsed) {
      return (
        <div key={entry.id}>
          <div style={{ borderTop: '1px solid #e9ecef', margin: '10px 10px' }}></div>
          {getLeafItems(entry).map(child => renderMenuEntry(child, 0))}
          <div style={{ borderBottom: '1px solid #e9ecef', margin: '10px 10px' }}></div>
        </div>
      );
    }

    const isExpanded = expandedGroups[entry.id];
    return (
      <div key={entry.id}>
        <div
          onClick={() => toggleGroup(entry.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 20px',
            paddingLeft: depth > 0 ? `${20 + depth * 16}px` : '20px',
            cursor: 'pointer',
            color: '#495057',
            justifyContent: 'space-between',
            transition: 'all 0.2s ease'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', minWidth: '20px' }}>{entry.icon}</div>
            <span style={{ marginLeft: '12px', fontWeight: 500 }}>{entry.label}</span>
          </div>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease'
            }}
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div style={{
          maxHeight: isExpanded ? '500px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out'
        }}>
          {entry.children.map(child => renderMenuEntry(child, depth + 1))}
        </div>
      </div>
    );
  };

  return (
    <div style={{
      width: collapsed ? '60px' : `${sidebarWidth}px`,
      backgroundColor: '#f8f9fa',
      borderRight: '1px solid #e9ecef',
      display: 'flex',
      flexDirection: 'column',
      transition: isResizing ? 'none' : 'width 0.3s ease',
      height: '100%',
      flexShrink: 0,
      position: 'relative',
      fontFamily: 'Arial',
      userSelect: 'none'
    }}>
      
      {!collapsed && (
        <div 
          onMouseDown={startResizing}
          style={{
            position: 'absolute',
            top: 0,
            right: -2, 
            width: '4px',
            height: '100%',
            cursor: 'col-resize',
            zIndex: 10,
            backgroundColor: isResizing ? '#1971c2' : 'transparent',
            transition: 'background-color 0.2s'
          }}
          title="Drag to resize"
        />
      )}

      <div style={{
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between',
        borderBottom: '1px solid #e9ecef',
        height: '60px',
        boxSizing: 'border-box'
      }}>
        {!collapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={process.env.PUBLIC_URL + '/runbusiness-logo.svg'} alt="RunBusiness" style={{ height: '28px', width: 'auto' }} />
          </div>
        )}
        <button 
          onClick={onToggle}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '5px',
            color: '#6c757d'
          }}
        >
          {collapsed ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
          )}
        </button>
      </div>

      <div style={{ padding: '10px 0', flex: 1, overflowY: 'auto' }}>
        {menuGroups.map(entry => renderMenuEntry(entry, 0))}
      </div>
    </div>
  );
}
